import { forwardRef } from 'react';
import { useScrollVisibility } from '../../../shared/hooks';
import { FeatureRow } from './FeatureRow';
import exerciseDetailsMockup from '../../../shared/assets/mockups/ExerciseDetails.webp';
import programLibraryMockup from '../../../shared/assets/mockups/ProgramLibrary.webp';
import feedMockup from '../../../shared/assets/mockups/Feed.webp';
import './MockupsSection.css';

interface FeatureData {
  mockupSrc: string;
  mockupAlt: string;
  title: string;
  description: string;
  bullets?: string[];
  reverse: boolean;
}

const FEATURES: FeatureData[] = [
  {
    mockupSrc: exerciseDetailsMockup,
    mockupAlt: 'Exercise details screen showing a bench press progress chart, strength level and personal records',
    title: 'Track your progress',
    description: 'Everything you log turns into stats, from a single exercise to your whole month.',
    bullets: [
      'Analytics for every exercise you do',
      'Strength levels, from Bronze to Diamond',
      'See which muscles you hit each workout',
      'Monthly training reports',
      "Complete history of every set you've logged",
    ],
    reverse: false,
  },
  {
    mockupSrc: programLibraryMockup,
    mockupAlt: 'Program library screen showing saved routines and a Push/Pull/Legs program',
    title: 'Plan your training',
    description: "Save your routines and they're ready every time you train.",
    bullets: [
      'Create and save your favorite routines',
      'Build a program for the whole week',
      'Start a saved routine in a couple of taps',
      'Free official programs, or ones other users made',
    ],
    reverse: true,
  },
  {
    mockupSrc: feedMockup,
    mockupAlt: 'Social feed screen showing a shared workout post with a photo and set list',
    title: 'Train with your friends',
    description: 'The support that keeps you showing up.',
    bullets: [
      'Share your workouts',
      'Follow your friends and see their training',
      'Find other lifters in the app',
      'Streaks, likes and comments',
    ],
    reverse: false,
  },
];

export const MockupsSection = forwardRef<HTMLElement>(function MockupsSection(_props, ref) {
  const { refs, visibleItems } = useScrollVisibility(FEATURES.length);

  return (
    <section className="mockups-section" ref={ref}>
      <div className="mockups-content">
        {FEATURES.map((feature, index) => (
          <FeatureRow
            key={feature.title}
            ref={(el) => { refs[index].current = el; }}
            mockupSrc={feature.mockupSrc}
            mockupAlt={feature.mockupAlt}
            title={feature.title}
            description={feature.description}
            bullets={feature.bullets}
            reverse={feature.reverse}
            visible={visibleItems[index]}
          />
        ))}
      </div>
    </section>
  );
});

export default MockupsSection;


